import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes, TitleStrategy } from '@angular/router';
import { Y42RouteReuseStrategyService } from '@y42/angular/router';
import { Y42TitleStrategy } from './core/routing/y42-title-strategy.service';

export const routes: Routes = [
  {
    path: 'not-found',
    loadChildren: () => import('@y42/core/not-found').then((m) => m.routes),
  },
  {
    path: 'error',
    loadChildren: () => import('@y42/core/external-error').then((m) => m.routes),
  },
  {
    path: 'verify-email',
    loadChildren: () => import('@y42/user/shared/verify-email').then((m) => m.routes),
  },
  {
    path: 'setup-profile',
    loadChildren: () => import('@y42/user/shared/setup-profile').then((m) => m.routes),
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('./org/org.module').then((m) => m.OrgModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [
    {
      provide: TitleStrategy,
      useClass: Y42TitleStrategy,
    },
    {
      provide: RouteReuseStrategy,
      useClass: Y42RouteReuseStrategyService,
    },
  ],
})
export class AppRoutingModule {}
